import { Outlet, useLocation } from 'react-router';

import Box from '@mui/material/Box';

import { useConnection } from 'src/hooks/useConnection';

import OfflinePage from 'src/pages/OfflinePage';

import Main from './Main';
import Header from './Header';
import MiniSideNav from './MiniSideNav';

function AppLayout() {
  const { isOnline } = useConnection();
  const location = useLocation();

  // Check if current path is a summary page
  const isSummaryPage = location.pathname.includes('/summary');

  return (
    <Box id="root__layout">
      <Header />
      <Box sx={{ display: 'flex', flex: 1 }}>
        {!isSummaryPage && (
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <MiniSideNav />
          </Box>
        )}
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
          <Main>{isOnline ? <Outlet /> : <OfflinePage />}</Main>
        </Box>
      </Box>
    </Box>
  );
}

export default AppLayout;
